import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62285454"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 1,
  class: "label"
}
const _hoisted_3 = {
  key: 0,
  class: "field has-text-danger"
}
const _hoisted_4 = { class: "icon is-small" }
const _hoisted_5 = { class: "field is-horizontal" }
const _hoisted_6 = { class: "field-label is-normal" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "field-body" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "help" }
const _hoisted_13 = { class: "field is-horizontal" }
const _hoisted_14 = { class: "field-label is-normal" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "field-body" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  class: "field is-horizontal"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label is-normal" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Emoji")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "field-body" }
const _hoisted_23 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_24 = {
  key: 2,
  class: "field is-horizontal"
}
const _hoisted_25 = { class: "field-label is-normal" }
const _hoisted_26 = { class: "label" }
const _hoisted_27 = { class: "field-body" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = { class: "field is-horizontal" }
const _hoisted_30 = { class: "field-label" }
const _hoisted_31 = {
  class: "label checkbox",
  for: "chk-human"
}
const _hoisted_32 = { class: "field-body" }
const _hoisted_33 = {
  key: 3,
  class: "field is-horizontal"
}
const _hoisted_34 = { class: "field-label is-normal" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "field-body" }
const _hoisted_37 = { class: "control" }
const _hoisted_38 = { class: "select is-fullwidth" }
const _hoisted_39 = { value: "weiblich" }
const _hoisted_40 = { value: "männlich" }
const _hoisted_41 = { value: "divers" }
const _hoisted_42 = { value: "nicht festgelegt" }
const _hoisted_43 = {
  key: 4,
  class: "field is-horizontal"
}
const _hoisted_44 = { class: "field-label is-normal" }
const _hoisted_45 = { class: "label" }
const _hoisted_46 = { class: "field-body" }
const _hoisted_47 = { class: "field" }
const _hoisted_48 = { class: "control" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "field is-horizontal" }
const _hoisted_51 = { class: "field-label is-normal" }
const _hoisted_52 = ["title"]
const _hoisted_53 = { class: "field-body" }
const _hoisted_54 = { class: "field" }
const _hoisted_55 = { class: "control" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "field is-horizontal" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label is-normal" }, null, -1))
const _hoisted_59 = { class: "field-body" }
const _hoisted_60 = ["title"]
const _hoisted_61 = { class: "field is-horizontal" }
const _hoisted_62 = { class: "field-label" }
const _hoisted_63 = ["title"]
const _hoisted_64 = { class: "field-body" }
const _hoisted_65 = { class: "field" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = ["title"]
const _hoisted_68 = ["title"]
const _hoisted_69 = ["title"]
const _hoisted_70 = {
  key: 5,
  class: "field is-horizontal"
}
const _hoisted_71 = { class: "field-label" }
const _hoisted_72 = {
  class: "label",
  for: "chk-new-checkbox"
}
const _hoisted_73 = { class: "field-body" }
const _hoisted_74 = {
  key: 6,
  style: {"margin-bottom":"1.5em"}
}
const _hoisted_75 = { class: "field-label is-normal" }
const _hoisted_76 = {
  class: "label",
  style: {"width":"100px"}
}
const _hoisted_77 = { class: "field-body" }
const _hoisted_78 = { class: "control" }
const _hoisted_79 = { class: "select is-fullwidth" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = { value: "0" }
const _hoisted_82 = { value: "1" }
const _hoisted_83 = { value: "2" }
const _hoisted_84 = { value: "3" }
const _hoisted_85 = { class: "field" }
const _hoisted_86 = { class: "control" }
const _hoisted_87 = ["value", "placeholder"]
const _hoisted_88 = { class: "field is-grouped is-grouped-centered is-grouped-multiline" }
const _hoisted_89 = { class: "control" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "control" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.addingNewAlter)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.t("addcontact")), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.t("editcontact")), 1)),
    _createElementVNode("form", {
      class: "form",
      onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editAlterFinished && _ctx.editAlterFinished(...args)), ["prevent"]))
    }, [
      (_ctx.invalidPosition)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, { icon: "exclamation-triangle" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("positiononmap")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t("name")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { 'is-danger': _ctx.invalidName }]),
                ref: "altername",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alterNameInUI) = $event)),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.commitEdit($event, 'name'))),
                type: "text",
                placeholder: _ctx.t('nickname')
              }, null, 42, _hoisted_11), [
                [_vModelText, _ctx.alterNameInUI]
              ])
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t("mandatoryfield")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", {
            class: "label",
            title: _ctx.t('socialrole')
          }, _toDisplayString(_ctx.t("role")), 9, _hoisted_15)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("input", {
              class: _normalizeClass(["input", { autovalue: _ctx.alter.roleDefault }]),
              type: "text",
              value: _ctx.localizedRole,
              list: "predefined-roles",
              onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurRole && _ctx.blurRole(...args))),
              onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focusRole && _ctx.focusRole(...args)))
            }, null, 42, _hoisted_18),
            (_openBlock(), _createElementBlock("datalist", {
              id: "predefined-roles",
              key: _ctx.langIsGerman() ? 'de' : 'en'
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langIsGerman() ? _ctx.roleOptions : _ctx.engRoleOptions, (value) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: value.german
                }, _toDisplayString(value.label), 1))
              }), 128))
            ]))
          ])
        ])
      ]),
      (_ctx.emoji)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.selectedEmoji == null || _ctx.selectedEmoji.length < 1
                  ? _ctx.t("noemoji")
                  : _ctx.selectedEmoji), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.emoji)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("selectEmoji")), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown", { 'is-active': _ctx.showEmojiPicker }])
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "button is-small",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojiPicker && _ctx.toggleEmojiPicker(...args)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("selectemoji")), 1)
                  ]),
                  (_ctx.selectedEmoji != null && _ctx.selectedEmoji.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeEmoji && _ctx.removeEmoji(...args))),
                        type: "button",
                        class: "button is-small",
                        style: {"margin-left":"10px"}
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("removeemoji")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_EmojiPicker, {
                        modelValue: _ctx.selectedEmoji,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedEmoji) = $event)),
                        native: true,
                        disableSkinTones: true,
                        onSelect: _ctx.onSelectEmoji
                      }, null, 8, ["modelValue", "onSelect"])
                    ])
                  ])
                ])
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("human")), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              id: "chk-human",
              type: "checkbox",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.alterHuman) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.alterHuman]
            ])
          ])
        ])
      ]),
      (_ctx.alterHuman)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", {
                class: "label",
                title: _ctx.t('altergender')
              }, _toDisplayString(_ctx.t("gender")), 9, _hoisted_35)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass({ autovalue: _ctx.alter.genderDefault }),
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.alterGender) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.t("female")), 1),
                    _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.t("male")), 1),
                    _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.t("diverse")), 1),
                    _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.t("notspecified")), 1)
                  ], 2), [
                    [_vModelSelect, _ctx.alterGender]
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("category")), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("input", {
                    class: "input",
                    value: _ctx.alterGender,
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.commitEdit($event, 'currentGender'))),
                    type: "text"
                  }, null, 40, _hoisted_49)
                ])
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("label", {
            class: "label",
            title: _ctx.t('agetitle')
          }, _toDisplayString(_ctx.t("age")), 9, _hoisted_52)
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("input", {
                class: "input",
                min: "0",
                value: _ctx.alter.age,
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.commitEdit($event, 'age'))),
                type: "number"
              }, null, 40, _hoisted_56)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("label", {
            class: "checkbox",
            title: _ctx.t('deceasedcheck')
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.alterDeceased) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.alterDeceased]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.SYMBOL_DECEASED) + _toDisplayString(_ctx.t("deceased")), 1)
          ], 8, _hoisted_60)
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("label", {
            class: "label",
            title: _ctx.t('relationtitle')
          }, _toDisplayString(_ctx.t("relationship")), 9, _hoisted_63)
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("fieldset", {
              disabled: !_ctx.isConnectable,
              class: "control radio-group"
            }, [
              _createElementVNode("label", {
                class: "radio",
                title: _ctx.t('existingtitle')
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.alterEdgeType) = $event)),
                  value: "1"
                }, null, 512), [
                  [_vModelRadio, _ctx.alterEdgeType]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("existing")), 1)
              ], 8, _hoisted_67),
              _createElementVNode("label", {
                class: "radio",
                title: _ctx.t('multititle')
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.alterEdgeType) = $event)),
                  value: "2"
                }, null, 512), [
                  [_vModelRadio, _ctx.alterEdgeType]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("multiplex")), 1)
              ], 8, _hoisted_68),
              _createElementVNode("label", {
                class: "radio",
                title: _ctx.t('norelationtitle')
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.alterEdgeType) = $event)),
                  value: "0"
                }, null, 512), [
                  [_vModelRadio, _ctx.alterEdgeType]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("nocurrentrelationship")), 1)
              ], 8, _hoisted_69)
            ], 8, _hoisted_66)
          ])
        ])
      ]),
      (_ctx.showQuality && _ctx.alterEdgeType >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.t("conflictual")), 1)
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  id: "chk-new-checkbox",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.alterConflict) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.alterConflict]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showQuality && _ctx.alterEdgeType >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportOptions, (label, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "field is-horizontal",
                key: key
              }, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.t(label)), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((_ctx.supportValues[key]) = $event)
                      }, [
                        _createElementVNode("option", _hoisted_81, _toDisplayString(_ctx.t("nosupport")), 1),
                        _createElementVNode("option", _hoisted_82, _toDisplayString(_ctx.t("isupport")) + " " + _toDisplayString(_ctx.alter.name), 1),
                        _createElementVNode("option", _hoisted_83, _toDisplayString(_ctx.alter.name) + " " + _toDisplayString(_ctx.t("supportsme")), 1),
                        _createElementVNode("option", _hoisted_84, _toDisplayString(_ctx.t("supporteachother")), 1)
                      ], 8, _hoisted_80), [
                        [_vModelSelect, _ctx.supportValues[key]]
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("textarea", {
            class: "textarea is-small",
            value: _ctx.alter.note,
            onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.commitEdit($event, 'note'))),
            placeholder: _ctx.t('notesaboutcontact')
          }, null, 40, _hoisted_87)
        ])
      ]),
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("p", _hoisted_89, [
          _createElementVNode("button", {
            class: "button is-primary",
            ref: "domButton",
            disabled: _ctx.invalidName || _ctx.invalidPosition
          }, _toDisplayString(_ctx.addingNewAlter ? _ctx.t("nextcontact") : _ctx.t("close")), 9, _hoisted_90)
        ]),
        _createElementVNode("p", _hoisted_91, [
          (_ctx.addingNewAlter)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button is-light",
                disabled: _ctx.invalidName || _ctx.invalidPosition,
                type: "button",
                onMouseup: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.editAlterFinished($event, false)), ["prevent"]))
              }, _toDisplayString(_ctx.t("close")), 41, _hoisted_92))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_93, [
          (_ctx.addingNewAlter)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button is-light",
                type: "button",
                onMouseup: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelAddAlter && _ctx.cancelAddAlter(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.t("cancel")), 33))
            : _createCommentVNode("", true)
        ])
      ])
    ], 32)
  ], 64))
}